export default __webpack_public_path__ + "65646396dd0edd3d733fa0a226018c6a.jpg";